<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
     
    </div>
    <span class="material-icons float-end CloseModal" (click)="onNoClick()"> close </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-center">
      {{data.title}}
    </h1>
    <p class="TxtModal text-center">
      {{data.text}}
    </p>

    <p class="TxtModal text-center">
      
        <button mat-button class="Btn BtnPadrao">
          <a href="{{this.help}}" target="_blank">
              Como liberar a localização
          </a>
        </button>
    </p>
    <p class="TxtModal text-center mt-5">
      <a target="_blank" class="lk-whats" href="{{whatsAppSac}}">
        <span class="material-icons">perm_phone_msg</span> 
        <span>Atendimento via WhatsApp</span>
      </a>
    </p>
  </div>
</div>
